export const GET_LIST_OF_ORGS = 'get_list_of_orgs';
export const GET_LIST_OF_ORGS_SUCCESSFUL = 'get_list_of_orgs_successful';
export const GET_LIST_OF_ORGS_FAILED = 'get_list_of_orgs_failed';